import React, { useEffect, useState } from 'react';
import API from "../../src/services/api";
import NoDataFound from '../shared/NoDataFound';
import TableLoader from '../shared/TableLoader';
import Paginator from '../shared/Paginator';
import config from '../config';

const DownloadCreativePreviews = () => {
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [paginatedData, setPaginatedData] = useState([]);

    const fetchProcessData = async (page = 0) => {
        setLoader(true);
        try {
            let res = await API({
                url: "/lineitems/getProcessdata",
                method: 'POST',
                responseType: 'json',
            });

            const allData = res.data;
            setData(allData);
            setTotalPages(Math.ceil(allData.length / config.PER_PAGE));

            // Calculate the slice of data for the current page
            const startIndex = page * config.PER_PAGE;
            const endIndex = startIndex + config.PER_PAGE;
            setPaginatedData(allData.slice(startIndex, endIndex));
        } catch (error) {
            console.error('Error fetching process data:', error);
        }
        setLoader(false);
    };

    const handlePageClick = (event) => {
        const newPage = event.selected;
        setCurrentPage(newPage);

        // Calculate new slice of data
        const startIndex = newPage * config.PER_PAGE;
        const endIndex = startIndex + config.PER_PAGE;
        setPaginatedData(data.slice(startIndex, endIndex));
    };

    useEffect(() => {
        fetchProcessData(0);
    }, []);

    const formatDate = (timestamp) => {
        if(timestamp==0) return 'Not Completed'
        const date = new Date(timestamp * 1000);
        return date.toLocaleString();
    };

    return (
        <>
            <div className='flex items-center mb-3'>
                <aside className="flex items-center gap-3 ml-auto flex-wrap w-full">
                    <h5 className='mr-auto'>Download Creative Previews</h5>
                </aside>
            </div>

            <div className='overflow-x-auto mb-4'>
                <table className='table table-bordered'>
                    <thead className="sticky top-0">
                        <tr>
                            <th>User Name</th>
                            <th>User Department</th>
                            <th>Status</th>
                            <th>Download Request ID</th>
                            <th>location</th>
                            <th>Interval</th>
                            <th>Process ID</th>
                            <th>Created Date</th>
                            <th>Completed At</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    {(paginatedData?.length && !loader) ? (
                        <tbody>
                            {paginatedData.map((item) => (
                                <tr key={item.process_id}>
                                    <td>{item.user_name}</td>
                                    <td>{item.user_department || '-'}</td>
                                    <td>
                                        {item.status === 0 && "Pending"}
                                        {item.status === 1 && "Ready for Download"}
                                        {item.status === 2 && "Failed"}
                                        {item.status === 3 && "Expired"}
                                    </td>
                                    <td>{item.download_request}</td>
                                    <td>{item.location || "-"}</td>
                                    <td>{item.interval}</td>
                                    <td>{item.process_id}</td>
                                    <td>{formatDate(item.download_request)}</td>
                                    <td>{formatDate(item.complete_request)}</td>
                                    <td>
                                        {item.status === 1 && (
                                            <a
                                                href={`${config.BASE_URL}creative_zipfiles/${item.process_id}_${item.location}.zip`}
                                                download
                                            >
                                                <button className="btn btn-primary">Download</button>
                                            </a>
                                        )}
                                        {item.status === "2" && (
                                            <span className="text-danger">Failed</span>
                                        )}
                                        {item.status === "3" && (
                                            <span className="text-danger">Expired</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        !paginatedData?.length && !loader
                            ? <NoDataFound colspan="7" />
                            : <TableLoader colspan="7" />
                    )}
                </table>
            </div>
            <div className='flex justify-end'>
                {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}
            </div>
        </>
    );
};

export default DownloadCreativePreviews;



// Gallery_mar_23 , APR 24 DFP , Fullvideo_new_mar_17 , 
